import { render, staticRenderFns } from "./ajUpload.vue?vue&type=template&id=de999856&scoped=true"
import script from "./ajUpload.vue?vue&type=script&lang=js"
export * from "./ajUpload.vue?vue&type=script&lang=js"
import style0 from "./ajUpload.vue?vue&type=style&index=0&id=de999856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de999856",
  null
  
)

export default component.exports